import qs from 'qs';
import merge from 'lodash.merge';
var getObjectValueByString = function (obj, path) {
    return path.split('.').reduce(function (acc, part) { return acc && acc[part]; }, obj);
};
export function validate(formFields) {
    var fieldsWithErrors = formFields.filter(function (field) { return !field.validate && field.error; });
    return function (keyValuePairs) {
        var errors = {};
        for (var _i = 0, fieldsWithErrors_1 = fieldsWithErrors; _i < fieldsWithErrors_1.length; _i++) {
            var _a = fieldsWithErrors_1[_i], name_1 = _a.name, error = _a.error;
            var fieldValue = getObjectValueByString(keyValuePairs, name_1);
            if (typeof error === 'function') {
                var errorMessage = error(fieldValue, keyValuePairs);
                var errorObject = qs.parse(name_1 + "=" + errorMessage, {
                    allowDots: true,
                });
                if (errorMessage)
                    return merge(errors, errorObject);
            }
            if (typeof error === 'string' &&
                (!fieldValue ||
                    (typeof fieldValue === 'string' && !fieldValue.trim()) ||
                    (Array.isArray(fieldValue) && !fieldValue.length))) {
                var errorObject = qs.parse(name_1 + "=" + error, {
                    allowDots: true,
                });
                merge(errors, errorObject);
            }
        }
        return errors;
    };
}
//# sourceMappingURL=validation.js.map